const Avatar = ({ firstName, lastName }) => (
  <div className="h-10 w-10 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center font-semibold text-sm">
    {(firstName?.[0] || "")}
    {(lastName?.[0] || "")}
  </div>
);

export default Avatar;